import './sampler-modal.css'
import BoxState from '../../scripts/lib/box-state.js'
import { setDisabled } from '../../scripts/lib/dom.js'
import { VIEW_TYPES, DEFAULT_MEAL_PLAN_URL } from '../../scripts/lib/constants.js'
import CustomerService from '../../scripts/lib/customer-service.js'

customElements.whenDefined('x-drawer').then((Drawer) => {
  class SamplerModal extends Drawer {
    #emailInput = null
    #submitButton = null
    #form = null
    #boundValidateEmail = null
    #boundHandleFormSubmit = null
    #boxState = null

    constructor() {
      super()

      this.#boundValidateEmail = () => this.#validateEmail()
      this.#boundHandleFormSubmit = (e) => {
        e.preventDefault()
        this.handleSubmit()
      }
    }

    get openFrom() {
      return 'top'
    }

    _setInitialPosition() {
      this.style.top = '0px'
      this.style.left = '0px'
      this.style.right = '0px'
      this.style.bottom = '0px'
    }

    connectedCallback() {
      super.connectedCallback()
      this.#boxState = BoxState.getInstance()

      this.render()
      this.#cacheElements()
      this.attachEventListeners()
      this.#validateEmail()
    }

    disconnectedCallback() {
      this.removeEventListeners()
    }

    #cacheElements() {
      this.#emailInput = this.querySelector('#sampler-email')
      this.#submitButton = this.querySelector('.sampler-modal__submit')
      this.#form = this.querySelector('form')
    }

    attachEventListeners() {
      this.#emailInput?.addEventListener('input', this.#boundValidateEmail)
      this.#form?.addEventListener('submit', this.#boundHandleFormSubmit)
    }

    removeEventListeners() {
      this.#emailInput?.removeEventListener('input', this.#boundValidateEmail)
      this.#form?.removeEventListener('submit', this.#boundHandleFormSubmit)
    }

    #validateEmail() {
      const isValid = this.#emailInput?.validity.valid ?? false
      setDisabled(this.#submitButton, !isValid)
    }

    async handleSubmit() {
      if (!this.#emailInput?.validity.valid) return

      const email = this.#emailInput.value.trim().toLowerCase()

      const { eligible, pets } = await this.#boxState.setEmail(email)

      if (eligible) {
        if (pets.length === 0) {
          this.#boxState.setSamplerStep('started')
          const mealPlanUrl = this.dataset.mealPlanUrl || DEFAULT_MEAL_PLAN_URL
          window.location.href = mealPlanUrl
        } else {
          this.#boxState.setSamplerStep('recipe')
          this.#boxState.activeView = VIEW_TYPES.SAMPLER
        }
      } else {
        const ineligibleDialog = document.querySelector('sampler-ineligible-dialog')
        if (ineligibleDialog) {
          const customerService = CustomerService.getInstance()
          const customerName = customerService.getCustomerName()
          ineligibleDialog.dataset.customerName = customerName
          ineligibleDialog.render()
          ineligibleDialog.show()
        }
      }

      this.hide()

      this.dispatchEvent(new CustomEvent('sampler:claim', {
        bubbles: true,
        detail: { email }
      }))
    }

    render() {
      const bannerImage = this.dataset.bannerImage || ''
      const hasImage = bannerImage !== ''
      const currentEmail = this.#boxState?.getCurrentEmail() || ''

      this.innerHTML = `
        <div slot="header" class="v:hidden">
          <h2 class="v:h5 v:l:h4">Claim Sampler Box</h2>
        </div>

        <div class="v:flex v:flex-col ${hasImage ? 'v:l:grid v:l:grid-cols-2' : ''} v:l:h-full">
          ${hasImage ? `
            <div class="v:relative v:w-full v:aspect-[2000/860] v:l:aspect-[400/396]">
              <img
                src="${bannerImage}"
                alt="Viva Raw Sampler Boxes"
                class="v:absolute v:w-full v:h-full v:object-cover v:object-center"
              />
            </div>
          ` : ''}

          <div class="v:flex v:flex-col v:gap-4 v:px-5 v:pt-4 v:pb-10 v:l:px-[50px] v:l:py-0 v:l:justify-center">
            <div class="v:flex v:flex-col v:gap-[10px] v:text-center v:l:text-left v:px-5 v:l:px-0">
              <h2 class="v:h5 v:l:h4">Claim Sampler Box</h2>
              <p class="v:text-body">
                Our 10lb sampler comes with a variety of proteins so you can see what works for your pet!
              </p>
            </div>

            <form class="v:flex v:flex-col v:gap-4 v:l:gap-[10px] v:pt-5 v:l:py-5">
              <div class="v:flex v:flex-col v:gap-1">
                <label for="sampler-email" class="v:field-label v:text-orange-dark">Email</label>
                <input
                  type="email"
                  id="sampler-email"
                  class="v:field-input"
                  placeholder="What's your email?"
                  value="${currentEmail}"
                  required
                />
              </div>

              <div class="v:flex v:flex-col v:items-center">
                <button
                  type="submit"
                  class="button v:button--primary v:button--sm sampler-modal__submit"
                  disabled
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      `
    }
  }

  if (!customElements.get('sampler-modal')) {
    customElements.define('sampler-modal', SamplerModal)
  }
})
